import DOMPurify from 'dompurify';

// The tags of the listing editor toolbar (bold, italic, bullet list). Pasted styles and images go away.
const LISTING_TAGS = ['p', 'br', 'b', 'strong', 'i', 'em', 'ul', 'li'];

export const sanitizeListingHtml = (html: string | null) =>
  DOMPurify.sanitize(html ?? '', {ALLOWED_TAGS: LISTING_TAGS, ALLOWED_ATTR: []});
